import * as x from "react";
import { i as m, E as v, x as d, r as w, a as y, c as b } from "../createReactComponent-58f9bea8.mjs";
import { n as a } from "../property-9daa16cd.mjs";
import { r as g } from "../state-7560d4dc.mjs";
import { e as c } from "../query-d94c86d2.mjs";
import { e as h } from "../class-map-2994e95e.mjs";
import { S as u } from "../slot-controller-fa97ce97.mjs";
import { r as f } from "../icon-c572aa57.mjs";
import { r as z } from "../icon-button-87ac6b5d.mjs";
import { T as $, r as T } from "../tooltip-cb602d1f.mjs";
import { R as C, r as k } from "../resize-handle-62b4d9ef.mjs";
import { g as R } from "../utils-cf5bbdd1.mjs";
import "../base-e16d29d8.mjs";
const I = m`
  :host {
    --exo-component-side-drawer-min-height: unset;
    --exo-component-side-drawer-margin-bottom: var(--exo-spacing-x-large);
    --exo-component-side-drawer-header-padding-bottom: var(--exo-spacing-none);
    --exo-component-side-drawer-height: 100vh;
    --exo-component-side-drawer-header-height: var(--exo-spacing-2x-large);
  }

  :host .side--drawer {
    position: fixed;
    width: 100vw;
    height: var(--exo-component-side-drawer-height);
    overflow-y: auto;
    background: var(--exo-color-background);
    padding: var(--exo-spacing-none) var(--exo-spacing-large);
    z-index: var(--exo-z-index-dialog);
    box-shadow: 0 var(--exo-spacing-3x-small) var(--exo-spacing-standard)
      var(--exo-color-shadow-moderate);
    opacity: 1;
    transition: opacity 0.3s, right 0.3s;
  }

  :host .side--drawer .side-drawer--resize {
    position: absolute;
    min-height: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: var(--exo-z-index-dialog);
  }

  :host .side--drawer-slot {
    margin-bottom: var(--exo-component-side-drawer-margin-bottom);
    display: flex;
    flex-direction: column;
    min-height: var(--exo-component-side-drawer-min-height);
  }

  :host .panel--header {
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: var(--exo-spacing-none);
    height: var(--exo-component-side-drawer-header-height);
    background: var(--exo-color-background);
    margin-right: calc(-1 * var(--exo-spacing-large));
    z-index: var(--exo-z-index-dialog);
    padding-bottom: var(--exo-component-side-drawer-header-padding-bottom);
    gap: var(--exo-spacing-large);
  }

  :host .panel--header .leading-icon {
    display: inline-block;
    color: var(--exo-color-icon-secondary);
  }

  :host .panel--header ex-icon-button {
    display: inline-block;
    color: var(--exo-color-font);
    margin: var(--exo-spacing-x-small);
  }

  :host .panel--header .header-icons {
    display: flex;
    align-items: center;
  }

  :host .panel--header .info-icon {
    z-index: var(--exo-z-index-tooltip-popup);
    margin: 0;
  }

  :host .panel--title {
    text-align: left;
    font: var(--exo-text-label-medium-bold);
    color: var(--exo-color-font);
    display: flex;
    align-items: center;
    flex-grow: 1;
    overflow: hidden;
    gap: var(--exo-spacing-x-small);
  }

  :host .panel--title ex-tooltip:part(tooltip1) {
    display: inline-block;
  }

  :host .panel--title > span {
    padding: var(--exo-spacing-none) var(--exo-spacing-3x-small);
    vertical-align: top;
    display: inline-block;
    max-width: calc(100% - 48px - (2 * var(--exo-spacing-x-small)));
  }


   :host .panel--title span .panel--title-label {
    overflow: hidden;
    text-overflow: ellipsis;
   }

  :host .side--drawer.space--right {
    right: calc(-100vw - (2 * var(--exo-spacing-large)));
    opacity: 0;
  }

  :host .panel--footer {
    position: sticky;
    bottom: var(--exo-spacing-none);
    height: calc(var(--exo-spacing-3x-large) - var(--exo-spacing-2x-small));
    background: var(--exo-color-background);
    margin-left: calc(-1 * var(--exo-spacing-large));
    margin-right: calc(-1 * var(--exo-spacing-large));
    z-index: var(--exo-z-index-dialog);
  }

  :host .panel--footer.hide {
    display: none;
  }

  @media only screen and (width <= 1399px) {
    :host .side--drawer {
      width: var(--exo-size-5);
    }
    :host .side--drawer.space--right {
      right: -100%;
      box-shadow: none;
      opacity: 0;
    }
  }
  @media only screen and (width >= 1400px) {
    :host .side--drawer {
      width: 33vw;
    }
    :host .side--drawer.space--right {
      right: calc(-33vw - (2 * var(--exo-spacing-large)));
      box-shadow: none;
      opacity: 0;
    }
  }

  @media only screen and (width <= 576px) {
    :host .side--drawer {
      width: calc(100vw - var(--exo-spacing-2x-large));
    }
    :host .panel--header {
      width: calc(100vw - var(var(--exo-spacing-3x-small)));
    }
  }

  .show--panel {
    right: 0;
  }
`;
var j = Object.defineProperty, D = Object.getOwnPropertyDescriptor, t = (r, o, i, s) => {
  for (var l, n = s > 1 ? void 0 : s ? D(o, i) : o, p = r.length - 1; p >= 0; p--)
    (l = r[p]) && (n = (s ? l(o, i, n) : l(n)) || n);
  return s && n && j(o, i, n), n;
};
class e extends v {
  constructor() {
    super(...arguments), this.slotController = new u(this, "footer"), this.label = "side drawer", this.panelTitle = "Main Header", this.infoText = "", this.open = !1, this.hideClose = !1, this.navigation = !1, this.footer = !1, this.top = 0, this.icon = "", this.leadingIconLabel = "", this.maxResize = 0.5 * window.innerWidth, this.minResize = 0.2 * window.innerWidth, this.resize = !1, this.showTitleTooltip = !1, this.adjustResizeHeight = () => {
      var s, l;
      const o = (s = this.shadowRoot) == null ? void 0 : s.querySelector(".side-drawer--resize"), i = (l = this.shadowRoot) == null ? void 0 : l.querySelector(".side--drawer");
      o && i && (o.style.display = "none", Object.assign(o.style, { height: `${i.scrollHeight}px` }), o.style.display = "block");
    }, this.updateTitleTooltipStatus = () => {
      var i;
      const o = (i = this.shadowRoot) == null ? void 0 : i.querySelector(".panel--title-label");
      o && (this.showTitleTooltip = o.scrollWidth > o.clientWidth);
    };
  }
  computePosition() {
    Object.assign(this.panel.style, { top: `${this.top}px`, height: `calc(var(--exo-component-side-drawer-height) - ${this.top}px)` });
  }
  firstUpdated() {
    this.computePosition(), this.mutationObserver = new MutationObserver(this.adjustResizeHeight), this.mutationObserver.observe(this.sideDrawer, { childList: !0, subtree: !0 }), this.sideDrawer.addEventListener("scroll", this.adjustResizeHeight), this.adjustResizeHeight();
  }
  disconnectedCallback() {
    this.mutationObserver.disconnect();
  }
  getDialogIcon() {
    return this.icon.trim() ? d`<ex-icon
          class="leading-icon"
          icon=${this.icon}
          size="S"
          label=${this.leadingIconLabel}
        ></ex-icon>` : "";
  }
  hidePanel() {
    this.open = !1, this.dispatchCustomEvent("onCancel");
  }
  closePanel() {
    this.open = !1, this.dispatchCustomEvent("onClose");
  }
  getLeftcaretIconButton() {
    return this.navigation ? d`<ex-icon-button
        icon="Left caret"
        type="tertiary"
        @click=${this.hidePanel}
        circular
        aria-label="hide"
        aria-description="hide the panel"
      ></ex-icon-button>` : "";
  }
  getcloseIconButton() {
    return this.hideClose ? "" : d`<ex-icon-button
      icon="Close"
      type="tertiary"
      @click=${this.closePanel}
      circular
      aria-label="close"
      aria-description="closes the panel"
      data-exo-locatorId-suffix=${R(this, "side-drawer-close-button")}
    ></ex-icon-button>`;
  }
  render() {
    const o = { "panel--footer": !0, hide: !this.slotController.test("footer") };
    return d` <div
      class=${h({ "side--drawer": !0, "show--panel": this.open, "space--right": !this.open })}
      aria-hidden="${!this.open}"
      tabindex="-1"
    >
      <div
        class=${h({ "panel--header": !0, "header--icon": this.icon.trim() })}
        aria-description="${this.panelTitle}"
        aria-label=${this.label}
      >
        <div class="panel--title" @mouseover=${this.updateTitleTooltipStatus}>
          ${this.getLeftcaretIconButton()} ${this.getDialogIcon()}
          <span>
            <ex-tooltip
              alignment="${$.MIDDLE}"
              .disable=${!this.showTitleTooltip}
            >
              ${this.panelTitle}
              <div slot="anchor" class="panel--title-label">
                ${this.panelTitle}
              </div>
            </ex-tooltip>
          </span>
          ${i = this.infoText, i ? d`<ex-icon-button
      icon="information"
      flavor="branded"
      type="tertiary"
      size="x-small"
      circular
      tooltipText=${i}
      class="info-icon"
    ></ex-icon-button>` : y}
        </div>
        <div class="header-icons">
          <slot name="header-icons"></slot>
          ${this.getcloseIconButton()}
        </div>
      </div>
      <div class="side--drawer-slot">
        <slot></slot>
      </div>
      <div class=${h(o)}>
        <slot name="footer"></slot>
      </div>
      ${this.resize ? d`<ex-resize-handle
            minWidth=${this.minResize}
            maxWidth=${this.maxResize}
            targetId=${this.id}
            class="side-drawer--resize"
            resize-parent
            position=${C.LEFT}
            @onResizeComplete=${this.adjustResizeHeight}
          ></ex-resize-handle>` : ""}
    </div>`;
    var i;
  }
}
e.styles = I, t([g()], e.prototype, "label", 2), t([c(".side--drawer")], e.prototype, "panel", 2), t([a()], e.prototype, "panelTitle", 2), t([a()], e.prototype, "infoText", 2), t([a({ type: Boolean })], e.prototype, "open", 2), t([a({ type: Boolean })], e.prototype, "hideClose", 2), t([a({ type: Boolean })], e.prototype, "navigation", 2), t([a({ type: Boolean })], e.prototype, "footer", 2), t([a()], e.prototype, "top", 2), t([a()], e.prototype, "icon", 2), t([a({ type: String })], e.prototype, "leadingIconLabel", 2), t([a({ type: Number, attribute: "max-resize" })], e.prototype, "maxResize", 2), t([a({ type: Number, attribute: "min-resize" })], e.prototype, "minResize", 2), t([a({ type: Boolean })], e.prototype, "resize", 2), t([g()], e.prototype, "showTitleTooltip", 2), t([c(".side--drawer")], e.prototype, "sideDrawer", 2), t([c(".side-drawer--resize")], e.prototype, "resizeHandler", 2);
const L = (r = "") => {
  w("ex-side-drawer", e, r), f(r), z(r), k(r), T(r);
}, A = b({ tagName: "ex-side-drawer", elementClass: e, react: x, events: { onCancel: "onCancel", onClose: "onClose" }, displayName: "ExSideDrawer", registerWebComponent: L });
export {
  A as ExSideDrawer,
  L as register
};
